<template lang="">
  <div class="Metabase">
    <v-container fluid grid-list-md>
      <v-layout row wrap justify-center>

        <v-flex xs12 lg10>
          <v-card
            class="px-3"
          >
            <v-card-title class="title">
              Reportes Guardados
            </v-card-title>

            <v-layout wrap align-start justify-center row fill-height>

              <v-flex xs12>
                <v-autocomplete
                  :items="savedReports"
                  label="Reportes"
                  v-model="selectedReport"
                  :disabled="loading"
                  color="secondary"
                  item-text="nombre"
                  return-object
                  hide-no-data
                  no-data-text="No se tienen Reportes Guardados."
                ></v-autocomplete>
              </v-flex>

              <v-card-text
                v-if="loading"
                class="text-xs-center"
              >
                <v-progress-circular
                  class="text-xs-center"
                  :size="progressSize"
                  :width="progressWidth"
                  color="info"
                  indeterminate
                ></v-progress-circular>
              </v-card-text>

              <v-card-text
                class="text-xs-center"
              >
                <iframe v-if="selectedReport"
                :src="selectedReport.url"
                frameborder="0"
                width="100%"
                height="600"
                allowtransparency
                ></iframe>
              </v-card-text>

            </v-layout>
          </v-card>
        </v-flex>

      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Metabase',

  components: {
  },

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
    console.log('fui creado')
    this.getSavedReportsMeta()
  },

  data: function () {
    return {
      backConf: {
        path: '/formularios/metabase/',
        page: 1
      },
      operativo: null,
      progressSize: 70,
      progressWidth: 7,
      loadingMuestra: false,
      loading: false,

      // Reporte Multiple
      loadReports: false,
      loadingReports: false,
      selectedReport: null,
      savedReports: [],

      dateIniReports: null,
      dateEndReports: null,

      dataReports: [],
      csvnameReports: ' '
    }
  },

  watch: {
  },

  computed: {

  },

  methods: {
    // para reporte multiple
    /**
     * Obtiene la lista de reportes guardados de metabase
     */
    getSavedReportsMeta () {
      this.loading = true

      let request = {
        method: 'get',
        params: {
          operativo: this.operativo
        },
        url: this.backConf.path
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.savedReports = resp.data
          t.loading = false
          t.loadingiframe = false
        })
        .catch(function (err) {
          t.savedReports = null
          t.loading = false
          console.error(err)
        })
    }

  }
}
</script>
